export function module_leadCapture() {
	$(function() {
		leadContents();

		var timer = false;
		var count = 0;
		var winWidth = $(window).width();
		var winHeight = $(window).height();
		var winWidth_resized;
		var winHeight_resized;

		//--------------------------------------------------------
		// Resize Event
		//--------------------------------------------------------
		$(window).on('resize', function() {
			// リサイズ後の放置時間が指定ミリ秒以下なら何もしない(リサイズ中に何度も処理が行われるのを防ぐ)
			if (timer !== false) {
				clearTimeout(timer);
			}

			// 放置時間が指定ミリ秒以上なので処理を実行
			timer = setTimeout(function() {
				// リサイズ後のウインドウの横幅・高さを取得
				winWidth_resized = $(window).width();
				winHeight_resized = $(window).height();

				// リサイズ前のウインドウ幅・髙さとリサイズ後のウインドウ幅・髙さが異なる場合
				if ( winWidth != winWidth_resized || winHeight != winHeight_resized ) {
					leadContents();

					// 次回以降使えるようにリサイズ後の幅・髙さをウインドウ幅に設定する
					winWidth = $(window).width();
					winHeight = $(window).height();
				}
			}, 200);
		});

		//リサイズ用関数
		function leadContents() {
			//timerをクリア、countをリセット
			clearTimeout(timer);
			count = 0;

			//画面高さを取得
			var wHeight = $(window).height();
			//ヘッダー高さを取得
			var headerHeight = $('#header').height();

			if(window.innerWidth >= 1024) {
				$('.mainVisualLP, .mainVisualLPInner').removeAttr('style');
				//メインビジュアル高さ
				$('.mainVisualLP').css('height', wHeight);
				$('.mainVisualLPInner').css({'marginTop': headerHeight, 'height': wHeight - headerHeight});
				$('.mainVisualLPHlBox').css('paddingTop', headerHeight);

				$(window).on('load', function () {
					//メインビジュアルのスクロールアニメーション
					$('.mainVisualLPHlBox').each(function () {
						var $winH = $(window).height(),
								$mainText = $(this),
								position = $mainText.offset().top,
								opacity = 1,
								scroll, visualScale, visualPosition;

						$(window).on('scroll', function () {
							scroll = $(window).scrollTop();
							opacity = (1 - (scroll - position) / ($winH * .5));
							visualScale = (1 + (scroll - position) / ($winH * 2));
							visualPosition = (1 + (scroll - position) / ($winH * .002));

							if (opacity > 0.99) {
								opacity = 1;
							}

							if (visualScale < 1) {
								visualScale = 1;
							}

							if (scroll > position - $winH) {
								$mainText.css({opacity: opacity, top: - visualPosition});
								$('.mainVisualLP').css({transform:'scale(' + visualScale + ')', top: - visualPosition});
							}


						});
					});
				});

			} else {

				$('.mainVisualLP, .mainVisualLPInner, .mainVisualLPHlBox').removeAttr('style');
				$('.mainVisualLP, .mainVisualLPInner').css('marginTop', headerHeight );
			}

			$(window).on('load scroll', function () {
				//スクロールが画面サイズを超えたら、メインビジュアルを非表示
				if ($(this).scrollTop() > wHeight + 100) {
					$('.mainVisualLP').hide();
				} else {
					$('.mainVisualLP').show();
				}
			});
		}
	});
}